export const SPRITE_VERSION = "3c5919b6";
